import { RefObject, useEffect } from 'react';

import { isGoogleLoginCredentialResponse } from './GoogleLoginCredentialResponse';

export type GoogleLoginSuccessCallback = (response: google.accounts.id.CredentialResponse) => void;

export function useGoogleLoginIFrameEventListener(
    ref: RefObject<HTMLIFrameElement>,
    googleClientId: string,
    successCallback: GoogleLoginSuccessCallback,
): void {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (!ref.current || event?.type !== 'message') {
                return;
            }
            const data = event.data as unknown;
            if (isGoogleLoginCredentialResponse(data)) {
                successCallback(data);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [ref, successCallback, googleClientId]);
}
